import axiosMiddleware from "./axiosMiddleware";

export const getAgentTransactionsAPI = ({ limit, offset }) => {
  return axiosMiddleware({
    method: "get",
    url: `agent/transaction/list?limit=${limit}&&offset=${offset}`,
    // data: postData,
  });
};

export const getAgentsBalancesAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: "/agents/balance",
  });
};

export const getAgentExchangeRateAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: "exchange-rate",
  });
};
